import { Box, Flex, StyleSystemProps, styled } from '@withjoy/joykit';

export const StyledBrandGroupContainer = styled(Flex)``;
const brandGroupContainerStyles: StyleSystemProps = {
  flexDirection: 'column',
  width: '100%',
  rowGap: 6
};

export const StyledBrandGroupWrapper = styled(Flex)``;
const brandGroupWrapperStyles: StyleSystemProps = {
  flexDirection: 'column',
  rowGap: 4
};

export const StyledBrandItem = styled(Box)``;
const brandItemStyles: StyleSystemProps = {
  cursor: 'pointer'
};

export const styles = {
  brandGroupContainer: brandGroupContainerStyles,
  brandGroupWrapper: brandGroupWrapperStyles,
  brandItem: brandItemStyles
};
